// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__yiXEF","title":"InfoRow_title__RppQI"};